
export default function InstagramFeed() {
  return (
    <section className="py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase mb-4">
            Follow Our Journey
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-[#2A2A2A] mb-6">
            @tadashi_interior_design
          </h2>
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-8 h-0.5 bg-[#D4AF37]"></div>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-instagram-line text-[#D4AF37] text-lg"></i>
            </div>
            <div className="w-8 h-0.5 bg-[#D4AF37]"></div>
          </div>
          <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Explore our latest luxury renovation projects, behind-the-scenes moments, and design inspiration on Instagram.
          </p>
        </div>

        {/* Instagram Embed */}
        <div className="flex justify-center">
          <div className="w-full max-w-4xl rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <iframe
              src="https://www.instagram.com/tadashi_interior_design/embed"
              className="w-full border-0"
              style={{ minHeight: '600px', height: '800px' }}
              title="Tadashi Consulting Instagram Feed"
              loading="lazy"
              allowTransparency={true}
              allow="encrypted-media"
            ></iframe>
          </div>
        </div>

        {/* CTA to Instagram */}
        <div className="text-center mt-10 md:mt-14">
          <a
            href="https://www.instagram.com/tadashi_interior_design?utm_source=qr&igsh=MWNzNGx6ajMzNjluMA%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 md:px-10 py-3.5 md:py-4 border-2 border-[#D4AF37] text-[#D4AF37] text-sm md:text-base font-semibold rounded-full hover:bg-[#D4AF37] hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-instagram-line text-lg"></i>
            </span>
            Follow Us on Instagram
          </a>
        </div>
      </div>
    </section>
  );
}
